import request from '@/utils/request2';
export function getNoticeTemplateResource(data) {
  return request.post('admin/user/insurance-notice/config-resource', data);
}
export function backInsuranceUploadFile(data) {
  return request.post('admin/user/insurance-notice/upload', data);
}